import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartCard from "./ChartCard";
import ChartTooltip from "./ChartTooltip";
import {
  axisProps,
  chart,
  formatMinutes,
  sentimentRating,
  sentimentScale,
} from "./theme";

function TeamComparisonChart({ teams, style }) {
  const data = [...teams].sort((a, b) => b.calls - a.calls);

  return (
    <ChartCard
      title="Teams"
      subtitle="Calls handled per team"
      height={Math.max(160, data.length * 44 + 24, 320)}
      style={style}
      table={{
        columns: ["Team", "Calls", "Avg sentiment", "Talk time"],
        rows: data.map((t) => [
          t.name,
          t.calls,
          Math.round(t.avg_sentiment),
          formatMinutes(t.talk_minutes),
        ]),
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 40, bottom: 0, left: 0 }}
          barCategoryGap="28%"
        >
          <CartesianGrid horizontal={false} stroke={chart.grid} />
          <XAxis type="number" allowDecimals={false} {...axisProps} />
          <YAxis
            type="category"
            dataKey="name"
            width={110}
            {...axisProps}
            axisLine={false}
            tick={{ fill: "rgba(255,255,255,0.75)", fontSize: 13 }}
          />
          <Tooltip
            cursor={{ fill: chart.cursor }}
            content={
              <ChartTooltip
                rows={(payload) => {
                  const t = payload[0].payload;
                  return [
                    { label: "Calls", value: t.calls, color: "#18a19c" },
                    {
                      label: "Avg sentiment",
                      value: Math.round(t.avg_sentiment),
                      color: sentimentScale[sentimentRating(t.avg_sentiment)],
                    },
                    {
                      label: "Talk time",
                      value: formatMinutes(t.talk_minutes),
                    },
                  ];
                }}
              />
            }
          />
          <Bar
            dataKey="calls"
            fill="#18a19c"
            radius={[0, 4, 4, 0]}
            maxBarSize={28}
          >
            <LabelList
              dataKey="calls"
              position="right"
              fill={chart.tick}
              fontSize={12}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}

export default TeamComparisonChart;
